let AdobeAn;
let exportRoot;
import createjs from 'createjs';
/* eslint-disable camelcase */

(function(cjs, an) {
    let p; // shortcut to reference prototypes
    const lib = {};
    const ss = {};
    const img = {};
    lib.ssMetadata = [];

    // symbols:
    // helper functions:

    function mc_symbol_clone() {
        const clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
        clone.gotoAndStop(this.currentFrame);
        clone.paused = this.paused;
        clone.framerate = this.framerate;
        return clone;
    }

    function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
        const prototype = cjs.extend(symbol, cjs.MovieClip);
        prototype.clone = mc_symbol_clone;
        prototype.nominalBounds = nominalBounds;
        prototype.frameBounds = frameBounds;
        return prototype;
    }

    (lib.Symbol6 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#B9C4E3')
            .s()
            .p('AjWF0IAAvfIGtD4IAAPfg');

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = getMCSymbolPrototype(lib.Symbol6, new cjs.Rectangle(-21.4, -61.9, 43, 124), null);

    (lib.Symbol5 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#B9C4E3')
            .s()
            .p('AjWF0IAAvfIGtD4IAAPfg');

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = getMCSymbolPrototype(lib.Symbol5, new cjs.Rectangle(-21.4, -61.9, 42.9, 124), null);

    (lib.Symbol4 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#FFFFFF')
            .s()
            .p('AqDB8INZnvIGuD4ItaHvg');

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = getMCSymbolPrototype(lib.Symbol4, new cjs.Rectangle(-64.4, -37.2, 128.8, 74.4), null);

    (lib.Symbol3 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#E7E7E7')
            .s()
            .p('AnsAyIIUkwIHFEFImtD4g');

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = getMCSymbolPrototype(lib.Symbol3, new cjs.Rectangle(-49.2, -25.4, 98.6, 51), null);

    (lib.Symbol2 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#9AA5C0')
            .s()
            .p('AlBC6IjXB8IAAveINanwIjWNjIGtj4ItabGg');

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));
    }).prototype = getMCSymbolPrototype(lib.Symbol2, new cjs.Rectangle(-53.6, -117.7, 107.4, 235.5), null);

    (lib.Symbol1sd = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .lf(['rgba(255,255,255,0.698)', 'rgba(255,255,255,0)'], [0, 1], -16.6, -95, 10, 57)
            .s()
            .p('ABaMZIl86lIDKBzIF7amg');
        this.shape.setTransform(27.3, 15.8);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .lf(['rgba(255,255,255,0.698)', 'rgba(255,255,255,0)'], [0, 1], -11.4, -65.1, 15.2, 86.9)
            .s()
            .p('AgtLKIl86lIHWERIF9amg');
        this.shape_1.setTransform(-13.8, -7.9);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol1sd, new cjs.Rectangle(-56.4, -106.6, 112.8, 213.3), null);

    (lib.Symbol7 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.Symbol2();
        this.instance.parent = this;
        this.instance.setTransform(-10.6, 130.2, 1, 1, 0, 0, 0, -32.1, 117.8);

        this.instance_1 = new lib.Symbol3();
        this.instance_1.parent = this;
        this.instance_1.setTransform(75.2, -44, 1, 1, 0, 0, 0, 49.3, 0);

        this.instance_2 = new lib.Symbol4();
        this.instance_2.parent = this;
        this.instance_2.setTransform(-32.8, -56.3, 1, 1, 0, 0, 0, -22.1, 36.6);

        this.instance_3 = new lib.Symbol5();
        this.instance_3.parent = this;
        this.instance_3.setTransform(-32.2, 43.4, 1, 1, 0, 0, 0, 21.4, 62);

        this.instance_4 = new lib.Symbol6();
        this.instance_4.parent = this;
        this.instance_4.setTransform(-10.7, 130.2, 1, 1, 0, 0, 0, 21.5, 62);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.instance_4}, {t: this.instance_3}, {t: this.instance_2}, {t: this.instance_1}, {t: this.instance}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol7, new cjs.Rectangle(-75.1, -130.1, 150.3, 260.3), null);

    // stage content:
    (lib._1 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_9 (mask)
        const mask = new cjs.Shape();
        mask._off = true;
        const mask_graphics_11 = new cjs.Graphics().p('AlBDOIjXB5IAAvwINanwIjWNkIGtj3ItabGg');

        this.timeline.addTween(
            cjs.Tween.get(mask)
                .to({graphics: null, x: 0, y: 0})
                .wait(11)
                .to({graphics: mask_graphics_11, x: 98.4, y: 162.3})
                .wait(20)
        );

        // Layer_10
        this.instance = new lib.Symbol1sd();
        this.instance.parent = this;
        this.instance.setTransform(2.7, 182.6, 1, 1.946, 0, 0, 0, 0, 0.1);
        this.instance._off = true;

        const maskedShapeInstanceList = [this.instance];

        for (let shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask;
        }

        this.timeline.addTween(
            cjs.Tween.get(this.instance)
                .wait(11)
                .to({_off: false}, 0)
                .to({regY: 0.2, scaleX: 1.1, scaleY: 2.13, rotation: -10.3, x: 209.7, y: 151.1}, 5)
                .wait(15)
        );

        // Слой 1
        this.instance_1 = new lib.Symbol7();
        this.instance_1.parent = this;
        this.instance_1.setTransform(76.9, 130.2);

        this.timeline.addTween(
            cjs.Tween.get(this.instance_1)
                .wait(8)
                .to({scaleY: 0.98, y: 152.2}, 3, cjs.Ease.get(1))
                .to({scaleY: 1, y: 149.9}, 2, cjs.Ease.get(-1))
                .wait(10)
                .to({y: 130.2}, 6, cjs.Ease.quadInOut)
                .wait(2)
        );
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(77.8, 141, 150.3, 260.3);
    // library properties:
    lib.properties = {
        id: '45945E4E9B394FC8B0EBDD7EB12C2B12',
        width: 152,
        height: 282,
        fps: 24,
        color: '#999999',
        opacity: 0.0,
        manifest: [],
        preloads: []
    };

    // bootstrap callback support:

    (lib.Stage = function(canvas) {
        createjs.Stage.call(this, canvas);
    }).prototype = p = new createjs.Stage();

    p.setAutoPlay = function(autoPlay) {
        this.tickEnabled = autoPlay;
    };
    p.play = function() {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
    };
    p.stop = function(ms) {
        if (ms) this.seek(ms);
        this.tickEnabled = false;
    };
    p.seek = function(ms) {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
    };
    p.getDuration = function() {
        return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
    };

    p.getTimelinePosition = function() {
        return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
    };

    an.bootcompsLoaded = an.bootcompsLoaded || [];
    if (!an.bootstrapListeners) {
        an.bootstrapListeners = [];
    }

    an.bootstrapCallback = function(fnCallback) {
        an.bootstrapListeners.push(fnCallback);
        if (an.bootcompsLoaded.length > 0) {
            for (let i = 0; i < an.bootcompsLoaded.length; ++i) {
                fnCallback(an.bootcompsLoaded[i]);
            }
        }
    };

    an.compositions = an.compositions || {};
    an.compositions['45945E4E9B394FC8B0EBDD7EB12C2B12'] = {
        getStage: function() {
            return exportRoot.getStage();
        },
        getLibrary: function() {
            return lib;
        },
        getSpriteSheet: function() {
            return ss;
        },
        getImages: function() {
            return img;
        }
    };

    an.compositionLoaded = function(id) {
        an.bootcompsLoaded.push(id);
        for (let j = 0; j < an.bootstrapListeners.length; j++) {
            an.bootstrapListeners[j](id);
        }
    };

    an.getComposition = function(id) {
        return an.compositions[id];
    };
})((createjs = createjs || {}), (AdobeAn = AdobeAn || {}));

const composition = AdobeAn.getComposition('45945E4E9B394FC8B0EBDD7EB12C2B12');

export {AdobeAn};
export {composition};
